<template>
    <div class="row">

        <div class="col-lg-4 checkout-content" style="min-height: 250px; padding-left: 0px; padding-right: 0px;" v-bind:style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
            <div class="d-flex justify-content-center shadow" style="background-color: white; opacity:0.5">
                <div class="p-3">
                    Choose the DAY you want for your<br /><span class="fw-bold" style="color:limegreen">Field Inspection</span>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3 mb-3">
                <div id="daypicker" class="daypicker shadow" />
            </div>
        </div>

        <div class="col-lg-8 p-0" v-if="Store.Checkout.SelectedDayAppointments">

            <div class="d-flex justify-content-center shadow" style="background-color: white; opacity:0.5">
                <div class="p-3" v-if="Store.Checkout.SelectedDayAppointments.length">
                    Choose the approximate TIME for the inspection on<br /><span class="fw-bold" style="color:limegreen">{{SelectedDayLongText}}</span>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-3 mb-3" v-if="Store.Checkout.SelectedDayAppointments.length">
                <!-- Create a table with 2 columns, fitting 2 appointments, i.e. apt objects in each row-->
                <table>
                    <tr v-for="(group, index) in Store.GroupedAppointments" :key="index">
                        <td v-for="appointment in group" :key="appointment.startTime">
                            <input v-model="Store.Checkout.Cart.ChosenAppointmentSlot" :value="appointment" type="radio" class="btn-check" name="btnradio" :id="'option' + appointment.startTime" autocomplete="off">
                            <label class="btn btn-outline-primary" :for="'option' + appointment.startTime">
                                {{ Store.FormatTime(appointment.startTime) }}<br />
                                <small>({{Store.TenantConfig.serviceConfigFieldInspection.inspectionDurationMinutes}} mins allot.)</small>
                                <br />
                                <span class="text-black">{{FormatAsMoney(GetFieldInspectionPrice(appointment))}}</span>
                            </label>
                        </td>
                    </tr>

                </table>
            </div>
        </div>
    </div>

</template>

<script>

    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'schedulerRON',
        components: {
        },
        props: {
        },
        data() {
            return {
                Store: {}
            };
        },
        methods:
        {
            FormatAsMoney(number) {
                // Convert to number if it's in string format or if it's falsy
                const num = (typeof number === 'string' || !number) ? parseFloat(number) : number;

                // Check if the conversion to number was successful or if it's still falsy
                if (isNaN(num) || !num) {
                    return "---";
                }

                // Format as USD currency
                return num.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
            },
            OnCmdNext: async function () {
                if (this.Store.Checkout.Cart.CurrentStep != 2) {
                    return;
                }
                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)
            },
            GetFieldInspectionPrice(appointment) {
                var now = new Date();
                var timespan = Math.round(((appointment.startTime || appointment.StartTime) - now) / (1000 * 60 * 60)); // Convert milliseconds to hours
                var minHoursNotice = this.Store.TenantConfig.serviceConfigFieldInspection.minHoursNotice;

                if (timespan < minHoursNotice) {
                    return -1; // No appointments scheduled less than these many hours in advance.
                }

                if (timespan >= minHoursNotice && timespan < this.Store.TenantConfig.serviceConfigFieldInspection.shortNoticeHourThreshold) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection.shortNoticeFee;
                }

                return this.Store.TenantConfig.serviceConfigFieldInspection.basicFee;
            },
            OnStepActivated: async function () {
                if (this.Store.Checkout.Cart.CurrentStep == 2 && this.Store.Checkout.Cart.SelectedService == "FieldInspection") {
                    this.Store.Checkout.NextButton.IsVisible = false;
                    this.Store.LoadSchedule();
                }
            }
        },
        computed:
        {
            
        },
        watch: {
            'Store.Checkout.Cart.ChosenAppointmentSlot': function (newVal, oldVal) {

                if (this.Store.Checkout.Cart.CurrentStep != 2) {
                    return;
                }

                if (newVal != null) {
                   
                    this.Store.Checkout.NextButton.Text = "Continue To Payment";
                    this.Store.Checkout.NextButton.Icon = "bi-cart-check";
                    this.Store.Checkout.NextButton.IsVisible = true;
                    this.Store.Checkout.Cart.Price = this.GetFieldInspectionPrice(newVal);
                }
                else {
                    this.Store.Checkout.Cart.Price = 0;
                    this.Store.Checkout.NextButton.IsVisible = false;
                }
            }
        },
        beforeMount: function () {

        },
        created() {
            this.Store = useEditorStore();
            EventHub.$on('OnCmdNext', this.OnCmdNext);
            EventHub.$on('OnStepActivated', this.OnStepActivated);
        },
        beforeUnmount() {
            EventHub.$off('OnCmdNext', this.OnCmdNext);
            EventHub.$off('OnStepActivated', this.OnStepActivated);
        },
      
    }
</script>

<style>
  
</style>